var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeworkEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.88672 1.88892H6.6645C3.60894 1.88892 2.38672 3.11114 2.38672 6.16669V9.83336C2.38672 12.8889 3.60894 14.1111 6.6645 14.1111H10.3312C13.3867 14.1111 14.6089 12.8889 14.6089 9.83336V8.61114",
    stroke: "#8A8A8A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9672 2.51221L6.15163 7.32777C5.9683 7.5111 5.78497 7.87166 5.7483 8.13444L5.48552 9.97388C5.38774 10.64 5.8583 11.1044 6.52441 11.0128L8.36385 10.75C8.62052 10.7133 8.98108 10.53 9.17052 10.3467L13.9861 5.5311C14.8172 4.69999 15.2083 3.73444 13.9861 2.51221C12.7639 1.28999 11.7983 1.6811 10.9672 2.51221Z",
    stroke: "#8A8A8A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2754 3.20276C10.6848 4.66331 11.8276 5.80609 13.2943 6.22165",
    stroke: "#8A8A8A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeworkEditIcon);
export default __webpack_public_path__ + "static/media/homework-edit-icon.45eb3aaf12f8593e82511e7c5487a2ae.svg";
export { ForwardRef as ReactComponent };